import { RootState } from '@reducers';

export const selectFeatureOrderTemplate = (state: RootState) => state.featureReducer.orderTemplateReducer;
